import Api from '@/services/Api'

export default {
   getCompanyAgencies () {
     return Api().get("/company-agencies");
  },
  updateCompanyAgency (params) {
    return Api().put("/company-agencies",params);
  },
  addCompanyAgency (params) {
    return Api().post("/company-agencies",params);
  },
  getCompanyAgency (params) {
    return Api().get("/company-agencies/"+params);
  },
  deleteCompanyAgency(params) {
    return Api().delete("/company-agencies/"+params);
  },
  getCompanyAgenciesByCompany (params) {
    return Api().get("/company-agencies-by-company/"+params);
  },
  deleteCompanyAgencyByCompany(params) {
    return Api().delete("/company-agencies-by-company/"+params);
  },

}



// WEBPACK FOOTER //
// ./src/services/CompanyAgencyService.js